import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  project: null,
  isInitialized: false,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setSelectedProject: (state, action) => {
      state.project = action.payload;
      state.isInitialized = true;
    },
  },
});

export const { setSelectedProject } = projectSlice.actions;

export default projectSlice.reducer;
